import { CWBClient } from "../../client";
import mockUserData from "../../mock/user-me.json";

export const getCurrentUserAPI = () =>
  process.env.REACT_APP_MOCK_ON === "TRUE"
    ? new Promise((resolve) => resolve({ data: mockUserData }))
    : CWBClient.get((process.env.REACT_APP_API_AUTH_ROOT_URL || "") + "/auth/user/me");
